export default class Timeline {
  constructor(element) {
    this.element = element;
    this.handle = this.element.querySelector('.timeline-handle');
    this.track = this.element.querySelector('.timeline-track');
    this.steps = this.element.querySelectorAll('.timeline-step');
    this.stepsWrapper = this.element.querySelector('.timeline-steps-wrapper');

    this.activeIndex = 0;
    this.dragging = false;
    this.isAnimating = false;
    this.autoplayInterval = 5000;
    this.autoplayDelay = 2000;

    this.init();
  }

  init() {
    if (!this.handle || !this.track || !this.steps.length) return;

    this.trackWidth = this.track.offsetWidth;
    this.handleWidth = this.handle.offsetWidth;

    this.totalStepsWidth = this.stepsWrapper.scrollWidth;
    this.visibleWidth = this.stepsWrapper.offsetWidth;

    this.steps.forEach((s) => {
      s.style.transition = 'opacity 0.3s ease';
    });
    this.stepsWrapper.style.transition = 'transform 0.6s ease';

    this.activateStep(0);
    this.setHandlePosition(30);

    this.startAutoplay();

    this.handle.addEventListener('mousedown', () => {
      this.dragging = true;
      this.stopAutoplay();
    });
    document.addEventListener('mouseup', () => {
      this.dragging = false;
      this.restartAutoplay();
    });
    document.addEventListener('mousemove', (e) => this.onDrag(e));

    this.handle.addEventListener('touchstart', () => {
      this.dragging = true;
      this.stopAutoplay();
    });
    document.addEventListener('touchend', () => {
      this.dragging = false;
      this.restartAutoplay();
    });
    document.addEventListener('touchmove', (e) => this.onDrag(e.touches[0]));
  }

  startAutoplay() {
    if (this.autoplay) clearInterval(this.autoplay);
    this.autoplay = setInterval(() => {
      if (!this.dragging && !this.isAnimating) {
        this.advanceStep();
      }
    }, this.autoplayInterval);
  }

  stopAutoplay() {
    clearInterval(this.autoplay);
  }

  restartAutoplay() {
    setTimeout(() => {
      if (!this.dragging) {
        this.startAutoplay();
      }
    }, this.autoplayDelay);
  }

  advanceStep() {
    const nextIndex = (this.activeIndex + 1) % this.steps.length;
    this.activateStep(nextIndex);

    const ratio = nextIndex / (this.steps.length - 1);
    this.moveCarousel(ratio);
    this.setHandlePosition(ratio * this.track.offsetWidth);

    this.animateStep(ratio);
  }

  animateStep(ratio) {
    if (this.isAnimating) return;

    this.isAnimating = true;
    const maxTranslate = this.totalStepsWidth - this.visibleWidth;
    const translateX = -ratio * maxTranslate;

    this.stepsWrapper.style.transform = `translateX(${translateX}px)`;

    this.steps.forEach((s, i) => {
      if (i < this.activeIndex) {
        s.style.opacity = '0';
      } else if (i === this.activeIndex) {
        s.style.opacity = '1';
      } else {
        s.style.opacity = '0.1';
      }
    });

    setTimeout(() => {
      this.isAnimating = false;
    }, 600);
  }

  onDrag(e) {
    if (!this.dragging) return;

    const rect = this.track.getBoundingClientRect();
    let x = e.clientX - rect.left;

    x = Math.max(0, Math.min(x, rect.width));

    this.handle.style.transition = 'none';
    this.setHandlePosition(x);

    const ratio = x / rect.width;

    this.stepsWrapper.style.transition = 'none';
    this.moveCarousel(ratio);

    const newIndex = Math.round(ratio * (this.steps.length - 1));
    if (newIndex !== this.activeIndex) {
      this.activateStep(newIndex);
    }

    this.animateStep(ratio);
  }

  setHandlePosition(x) {
    this.handle.style.position = 'absolute';
    this.handle.style.left = `${x - this.handleWidth / 2}px`;
  }

  moveCarousel(ratio) {
    const maxTranslate = this.totalStepsWidth - this.visibleWidth;
    const translateX = -ratio * maxTranslate;
    this.stepsWrapper.style.transform = `translateX(${translateX}px)`;
  }

  activateStep(index) {
    this.steps.forEach((s, i) => {
      if (i < index) {
        s.style.opacity = '0';
      } else if (i === index) {
        s.style.opacity = '1';
      } else {
        s.style.opacity = '0.1';
      }
    });
    this.activeIndex = index;
  }
}
